/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterOrigin_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilterOrigin_viewer";
};
export type SbSharedRefineMenuFilterOrigin_viewer$data = SbSharedRefineMenuFilterOrigin_viewer;
export type SbSharedRefineMenuFilterOrigin_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterOrigin_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterOrigin_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterOrigin_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '14194ad7a0d4d805cf2e7d5c2687e616';
export default node;
